import React, { useEffect, useState } from 'react';

const Notification = ({ message, status}) => {
    const [emojiIcon, setemojiIcon] = useState(null)
    useEffect(() => {
        if(status === "success"){
            setemojiIcon("✅")
        }else{
            if(status === "error"){
                setemojiIcon("❌")
            }else{
                setemojiIcon("⚠️")
            }
        }
       
    }, []);

    return (
        <div
            style={{
                position: "fixed",
                top: 20,
                right: 20,
                backgroundColor: "#333",
                color: "#fff",
                padding: "10px 16px",
                borderRadius: 8,
                boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
                fontSize: 14,
                zIndex: 9999,
                opacity: 0.9,
                transition: "opacity 0.3s",
            }}
        >
            {message + " " + emojiIcon}
        </div>
    );
}

export default Notification;
